import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../../Navigation";
import { RegDiv } from "../../Components";
import "../../index.css";
import {
  getLanguage,
  setLanguage,
  subscribeLanguage,
} from "../../global/language";

export default function HomePage() {
  const [showModal, setShowModal] = useState(false);
 
    const [language, updateLanguage] = useState(getLanguage());

    useEffect(() => {
    return subscribeLanguage((lang) => {
        updateLanguage(lang);
    });
    }, []);
  // Lock background scroll when modal opens
  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  const text = {
    en: {
      heroTitle: "Welcome to TennisMaster Club",
      heroDesc:
        "Join a global cyber tennis community where players improve together using AI coaching, organize games, and connect anywhere in the world.",

      joinNow: "Join Free Today",
      download: "Download App",

      about: "About TennisMaster Club",
      aboutDesc:
        "TennisMaster Club is a global digital tennis community powered by the Tennis Master AI Coach app. Members enjoy free access to AI-powered tennis coaching, tennis knowledge, and professional training videos to help improve skills anytime, anywhere.",
      aboutDesc1:
        "Members can also organize matches, connect with players of similar skill levels, and participate in local or international tennis community activities — making it easy to stay active and connected while traveling between different cities and countries.",
      aboutDesc2:
        "Whether you want to train smarter, meet new tennis partners, or improve your game, TennisMaster Club combines AI coaching and a global tennis network in one platform.",

      benefits: "Why Join TennisMaster Club?",
      free: "100% Free Membership",
      aiCoach: "AI Tennis Coaching & Swing Analysis",
      videos: "Watch Professional Coaching Videos",
      matchmaking: "Find Similar Skill-Level Players",
      organize: "Organize Singles & Doubles Games",
      global: "Join Club Activities Across Cities & Countries",
      travel: "Stay Connected While Traveling",
      community: "Friendly Global Tennis Community",

      howTitle: "How It Works",
      step1: "1. Download Tennis Master",
      step1Desc:
        "Install the Tennis Master AI Coach app on your phone or tablet.",

      step2: "2. Register Free Membership",
      step2Desc:
        "Create your TennisMaster Club account and join the community instantly.",

      step3: "3. Start Improving & Connecting",
      step3Desc:
        "Analyze strokes, learn from coaching videos, organize games, and meet tennis players worldwide.",

      featureTitle: "Club Features",
      improve: "AI-powered swing analysis & instant feedback",
      learn: "Tennis learning library & coaching tutorials",
      events: "Local and international tennis meetups",
      ranking: "Skill-level matching and player networking",
      anywhere: "Play and connect from any city or country",
      social: "Build friendships through tennis",

      ctaTitle: "Start Your Tennis Journey Today",
      ctaDesc:
        "Your AI tennis coach and global tennis club — all in one app.",

      modalTitle: "Download App and Register Membership",
      iphone: "iPhone / iPad",
      android: "Android Phone",
      appStore: "Download on App Store",
      apk: "Download on Google Play",
    },

    zh: {
      heroTitle: "欢迎加入 TennisMaster 网球俱乐部",
      heroDesc:
        "加入全球线上网球社区，利用 AI 教练提升球技、组织比赛，并与世界各地球友互动交流。",

      joinNow: "立即免费加入",
      download: "下载应用",

      about: "关于 TennisMaster Club",
      aboutDesc:
        "TennisMaster Club 是全球数字化网球社区，由 Tennis Master AI Coach 提供支持。会员可以提升球技、学习高级技巧、组织比赛，并与相同水平的球员建立联系，无论身在何处。",
      aboutDesc1:
        "会员还可以组织比赛、结识水平相近的球友，并参与本地或国际网球社区活动，让您在前往不同城市和国家旅行时，依然能够轻松参与您最喜欢的网球运动与社交联系。",
      aboutDesc2:
        "无论您希望更高效地训练、结识更多网球伙伴，还是全面提升球技，TennisMaster Club 都将 AI 教练与全球网球社群融合于一个平台之中。",

      benefits: "为什么加入 TennisMaster Club？",
      free: "永久免费会员",
      aiCoach: "AI 网球动作分析与指导",
      videos: "观看专业网球教学视频",
      matchmaking: "寻找相同水平球友",
      organize: "组织单打与双打比赛",
      global: "参与全球各城市与国家的俱乐部活动",
      travel: "旅行期间依然保持球友联系",
      community: "友好的国际网球社区",

      howTitle: "如何开始",
      step1: "1. 下载 Tennis Master",
      step1Desc:
        "在手机或平板安装 Tennis Master AI Coach 应用。",

      step2: "2. 免费注册会员",
      step2Desc:
        "创建 TennisMaster Club 账户，立即加入全球社区。",

      step3: "3. 开始提升与互动",
      step3Desc:
        "分析动作、学习教学视频、组织比赛，并认识全球网球爱好者。",

      featureTitle: "俱乐部特色",
      improve: "AI 挥拍分析与即时反馈",
      learn: "网球学习资料库与教学课程",
      events: "本地及国际网球活动",
      ranking: "球技匹配与球员社交",
      anywhere: "在任何城市与国家都能交流打球",
      social: "通过网球建立友谊",

      ctaTitle: "开启您的网球旅程",
      ctaDesc:
        "您的 AI 网球教练与全球网球社区，尽在一个应用中。",

      modalTitle: "下载应用并注册为会员",
      iphone: "苹果 iPhone / iPad",
      android: "安卓",
      appStore: "App Store 下载",
      apk: "Google Play下载",
    },
  };

  const t = text[language];

  return (
    <div className="font-sans bg-gray-50 text-gray-900">
      {/* SEO */}
      <Helmet>
        <title>
          TennisMaster Club – Global AI Tennis Community
        </title>

        <meta
          name="description"
          content="Join TennisMaster Club — a free worldwide tennis community powered by AI coaching, tennis learning, match organization, and player networking."
        />

        <meta
          name="keywords"
          content="tennis club, AI tennis coach, tennis community, tennis matchmaking, tennis training, tennis app, tennis games"
        />

        <meta
          property="og:title"
          content="TennisMaster Club"
        />

        <meta
          property="og:description"
          content="Global AI-powered tennis community."
        />

        <meta
          property="og:type"
          content="website"
        />
      </Helmet>

      {/* Navbar */}
      <RegDiv>
        <RegDiv height="2vw"></RegDiv>

        <Navbar language={language} />

        <div className="flex justify-end px-6 mt-4">
          <button
            onClick={() =>
              setLanguage(language === "en" ? "zh" : "en")
            }
            className="px-4 py-2 bg-green-700 text-white rounded-lg shadow hover:bg-green-800 transition"
          >
            {language === "en" ? "中文" : "English"}
          </button>
        </div>
      </RegDiv>

      {/* HERO */}
      <section className="relative w-full py-24 text-white text-center px-6 overflow-hidden bg-[url('/images/tennis-court-bg.jpg')]">
        
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('/images/tennis-club-bg.jpg')",
          }}
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/55" />

        {/* Content */}
        <div className="relative z-10 max-w-5xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-6 drop-shadow-lg">
            {t.heroTitle}
          </h1>

          <p className="text-lg md:text-2xl max-w-3xl mx-auto opacity-90 mb-10">
            {t.heroDesc}
          </p>

          <div className="flex justify-center gap-4 flex-wrap">
            <button
              onClick={() => setShowModal(true)}
              className="px-7 py-4 bg-yellow-400 text-black rounded-xl font-bold shadow-lg hover:scale-105 transition"
            >
              {t.joinNow}
            </button>

            <button
              onClick={() => setShowModal(true)}
              className="px-7 py-4 bg-white text-green-700 rounded-xl font-bold shadow-lg hover:scale-105 transition"
            >
              {t.download}
            </button>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="max-w-5xl mx-auto py-16 px-6">
        <h2 className="text-3xl font-bold text-green-800 mb-6">
          {t.about}
        </h2>

        <p className="text-lg leading-relaxed">
          {t.aboutDesc} <br></br> <br></br>
          {t.aboutDesc1} <br></br> <br></br>
          {t.aboutDesc2} <br></br> <br></br>
          
        </p>
      </section>

      {/* BENEFITS */}
      <section className="bg-white py-16 border-t">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-green-800 mb-10">
            {t.benefits}
          </h2>

          <div className="grid md:grid-cols-2 gap-8 text-lg">
            <div>✅ {t.free}</div>
            <div>🎾 {t.aiCoach}</div>
            <div>🎥 {t.videos}</div>
            <div>🤝 {t.matchmaking}</div>
            <div>📅 {t.organize}</div>
            <div>🌎 {t.global}</div>
            <div>✈️ {t.travel}</div>
            <div>❤️ {t.community}</div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="bg-green-50 py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-green-800 mb-12">
            {t.howTitle}
          </h2>

          <div className="grid md:grid-cols-3 gap-10">
            <div className="bg-white p-6 rounded-2xl shadow">
              <h3 className="text-xl font-bold mb-3">
                {t.step1}
              </h3>

              <p>{t.step1Desc}</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow">
              <h3 className="text-xl font-bold mb-3">
                {t.step2}
              </h3>

              <p>{t.step2Desc}</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow">
              <h3 className="text-xl font-bold mb-3">
                {t.step3}
              </h3>

              <p>{t.step3Desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="max-w-5xl mx-auto py-16 px-6">
        <h2 className="text-3xl font-bold text-green-800 mb-8">
          {t.featureTitle}
        </h2>

        <ul className="grid md:grid-cols-2 gap-8 text-lg">
          <li>⚡ {t.improve}</li>
          <li>📚 {t.learn}</li>
          <li>🎾 {t.events}</li>
          <li>🏆 {t.ranking}</li>
          <li>🌍 {t.anywhere}</li>
          <li>🤝 {t.social}</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="text-center py-20 bg-green-700 text-white">
        <h2 className="text-4xl font-bold mb-4">
          {t.ctaTitle}
        </h2>

        <p className="text-lg mb-8 opacity-90">
          {t.ctaDesc}
        </p>

        <button
          onClick={() => setShowModal(true)}
          className="px-8 py-4 bg-yellow-400 text-black rounded-xl font-bold shadow-lg hover:scale-105 transition"
        >
          {t.joinNow}
        </button>
      </section>

      {/* DOWNLOAD MODAL */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="
              bg-white rounded-2xl p-6
              max-w-3xl w-full
              max-h-[85vh]
              overflow-y-auto
              relative shadow-2xl
            "
          >
            {/* Close */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-2xl text-gray-500 hover:text-black"
              aria-label="Close modal"
            >
              ×
            </button>

            <h2 className="text-3xl font-bold text-center text-green-700 mb-8">
              {t.modalTitle}
            </h2>

            <div className="grid md:grid-cols-2 gap-10">

              {/* iPhone */}
              <div className="text-center border rounded-xl p-6 shadow-sm">
                <h3 className="text-2xl font-semibold mb-4">
                  {t.iphone}
                </h3>

                <img
                  loading="lazy"
                  src="https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=https://apps.apple.com/us/app/tennis-master-ai-tennis-coach/id6755618827"
                  alt="Apple Store QR Code"
                  className="mx-auto mb-4"
                />

                <a
                  href="https://apps.apple.com/us/app/tennis-master-ai-tennis-coach/id6755618827"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-5 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition"
                >
                  {t.appStore}
                </a>
              </div>

              {/* Android */}
              <div className="text-center border rounded-xl p-6 shadow-sm">
                <h3 className="text-2xl font-semibold mb-4">
                  {t.android}
                </h3>

                <img
                  loading="lazy"
                  src="https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=https://play.google.com/store/apps/details?id=com.anonymous.TennisMaster"
                  alt="Android APK QR Code"
                  className="mx-auto mb-4"
                />

                <a
                  href="https://play.google.com/store/apps/details?id=com.anonymous.TennisMaster"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-5 py-3 bg-green-700 text-white rounded-lg hover:bg-green-800 transition"
                >
                  {t.apk}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}